import { inject, observer } from 'mobx-react';
import FilteredPrematchesList from '../../mobile/components/filtered-prematches/filtered-prematches-list';
import React, { Fragment } from 'react';
import LLMatchesListItem from '../../desktop/components/matches-list-item';
import { RenderBreadcrumbs } from '../../desktop/components/matches-list';
import { trans } from '../../../../common/utils';


const MyFavoritesMatchesList = (
    {
        type,
        store,
    }
) => {
    const viewSize = store.site.status.viewSize;

    const matches = store.betting.favorites.favoriteMatches({ type });

    return viewSize === 'mobile' ? (
        <FilteredPrematchesList matches={matches} viewSize={store.site.status.viewSize} type={`fav${type}Matches`} />
    ) : (
        <div className="match-list">
            {!Object.keys(matches).length ? (
                <p className="match-list__search-no-data-text">
                    {trans(
                        {
                            favteamsMatches: 'FAV_TEAMS_MATCHES_NO_DATA_TEXT',
                            favtournamentsMatches: 'FAV_TOURNAMENTS_MATCHES_NO_DATA_TEXT',
                        }[`fav${type}Matches`]
                    )}
                </p>
            ) : (
                Object.keys(matches).map((tournamentId) => {
                    const tournament = matches[tournamentId];
                    return (
                        <Fragment key={tournamentId}>
                            {tournament && <RenderBreadcrumbs match={tournament} />}
                            {Object.keys(tournament.matches).map((matchStartDate, i) => {
                                const matchesByDate = tournament.matches[matchStartDate];
                                return (
                                    <Fragment key={matchStartDate}>
                                        <div className="match-list__date">{matchStartDate}</div>
                                        {matchesByDate.map((match, y) => {
                                            return (
                                                <LLMatchesListItem
                                                    key={y}
                                                    match={match}
                                                    customClasses={Object.keys(tournament.matches).length - 1 === i && matchesByDate.length - 1 === y ? 'match--last-in-list' : ''}
                                                />
                                            );
                                        })}
                                    </Fragment>
                                );
                            })}
                        </Fragment>
                    );
                })
            )}
        </div>
    );
}

export default inject('store')(observer(MyFavoritesMatchesList));